/*
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */


import { Injectable } from '@angular/core';

import { ElTreeGridPresentationNode } from './tree-grid.model';

export interface ElToggleOptions {
    deep?: boolean;
}

@Injectable()
export class ElTreeGridService<T> {
    expand(data: ElTreeGridPresentationNode<T>[], row: T, options: ElToggleOptions = {}) {
        const node: ElTreeGridPresentationNode<T> = this.find(data, row);
        node.expanded = true;

        if (options.deep && node.hasChildren()) {
            node.children.forEach((n: ElTreeGridPresentationNode<T>) => this.expand(data, n.data, options));
        }
    }

    collapse(data: ElTreeGridPresentationNode<T>[], row: T, options: ElToggleOptions = {}) {
        const node: ElTreeGridPresentationNode<T> = this.find(data, row);
        node.expanded = false;

        if (options.deep && node.hasChildren()) {
            node.children.forEach((n: ElTreeGridPresentationNode<T>) => this.collapse(data, n.data, options));
        }
    }

    toggle(data: ElTreeGridPresentationNode<T>[], row: T, options: ElToggleOptions = {}) {
        const node: ElTreeGridPresentationNode<T> = this.find(data, row);
        if (node.expanded) {
            this.collapse(data, row, options);
        } else {
            this.expand(data, row, options);
        }
    }

    private find(data: ElTreeGridPresentationNode<T>[], row: T): ElTreeGridPresentationNode<T> {
        const toCheck: ElTreeGridPresentationNode<T>[] = [...data];

        for (const node of toCheck) {
            if (node.data === row) {
                return node;
            }

            if (node.hasChildren()) {
                toCheck.push(...node.children);
            }
        }
    }
}
